// extracted by mini-css-extract-plugin
module.exports = {"drawer":"LanguageDrawer_drawer__3hoHA","helperTextD":"LanguageDrawer_helperTextD__3Hf79"};